<template>
    <div class="train-list">
        <ui-header :nav-num="3" :user-info="userInfo" :nav="nav" :login-url="loginUrl" :logout-url="logoutUrl"
                   :register-url="registerUrl" :home-url="homeUrl" :ucenter-url="ucenterUrl"></ui-header>
        <div class="train-main">
            <div class="crumb">
                <a :href="mainUrl" target="_blank" class="crumb-item">首页 </a>
                <a :href="pxUrl" target="_blank" class="crumb-item"> > 培训 </a>
                <a class="crumb-unclick"> > {{typeName}}</a>
            </div>
            <div class="list">
                <div class="list-left">
                    <div class="list-head">
                        <div>{{typeName}}</div>
                    </div>
                    <div class="list-main" >
                        <div class="list-item" v-for="(item, index) in listInfo">
                            <div class="list-point"></div>
                            <div class="list-text" v-on:click="openUrl(item.articleUrl)" v-html="item.title">
                            </div>
                        </div>
                    </div>
                    <div class="detail-pagination">
                        <commonPagination :pageIndex="pageIndex" :totalNum="totalNum" v-on:changeItem="changeItem"></commonPagination>
                    </div>
                </div>
                <div class="list-right" v-if="recommonAnalystArr.length != 0">
                    <div class="list-head">
                        <div>推荐分析师</div>
                    </div>
                    <div style="padding:0px 20px;">
                        <div class="list-per" v-for="(item, index) in recommonAnalystArr">
                            <img :src="item.analystImg" v-on:click="openUrl(item.analystUrl)">
                            <div class="any-name" v-on:click="openUrl(item.analystUrl)">
                                {{item.analystName}}
                            </div>
                            <div class="any-att">
                                已认证
                            </div>
                            <div class="any-authName">
                                {{item.authName}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <online-service></online-service>
        <img src="./images/toUp.png" class="toUp" v-show="isShowToUp" v-on:click="clickToUp()">
        <ui-footer style="margin-top:80px;"></ui-footer>
    </div>
</template>
<style lang="scss" scoped>
    .train-main{
        width: 1120px;
        margin: 0 auto;
        overflow: hidden;
        .crumb{
            height: 20px;
            margin: 5px 0;
            font-size: 14px;
            .crumb-item{
                color: #666666;
            }
            .crumb-unclick{
                color:#364983;
                cursor: default;
            }
        }
        .list{
            width: 100%;
            overflow: hidden;
            .list-left{
                float: left;
                width: 856px;
                .list-head{
                    height: 65px;
                    padding: 20px 50px;
                    border-bottom: 1px solid rgba(0,0,0,0.12);
                    background: white;
                    div{
                        font-size: 18px;
                        color: #364983;
                    }
                }
                .list-main{
                    padding: 20px 50px;
                    background: white;
                    .list-item{
                        margin-bottom: 20px;
                        height: 22px;
                        .list-point{
                            float: left;
                            width: 5px;
                            height: 5px;
                            background: #d8d8d8;
                            margin-right: 10px;
                            margin-top: 8px;
                        }
                        .list-text{
                            float: left;
                            width: 650px;
                            height: 100%;
                            font-size: 16px;
                            color: #333333;
                            cursor: pointer;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow:ellipsis;
                        }
                    }
                }
            }
            .list-right{
                width:244px;
                float: left;
                margin-left: 20px;
                background: white;
                .list-head{
                    height: 65px;
                    padding: 20px;
                    border-bottom: 1px solid rgba(0,0,0,0.12);
                    div{
                        font-size: 18px;
                        color: #364983;
                    }
                }
                .list-per{
                    padding:20px 0;
                    border-bottom: 1px solid rgba(0,0,0,0.12);
                    overflow: hidden;
                    img{
                        height: 72px;
                        width: 72px;
                        float: left;
                        cursor: pointer;
                    }
                    .any-name{
                        float: left;
                        margin-top: 10px;
                        margin-left: 10px;
                        font-size: 14px;
                        color: #364983;
                        width: 42px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow:ellipsis;
                        cursor: pointer;
                    }
                    .any-att{
                        float: right;
                        margin-top: 10px;
                        margin-right: 10px;
                        width: 62px;
                        height: 22px;
                        border: 1px solid #999;
                        border-radius: 3px;
                        color: #999;
                        font-size: 12px;
                        text-align: center;
                        line-height: 20px;
                    }
                    .any-authName{
                        float: left;
                        margin-top: 10px;
                        margin-left: 10px;
                        font-size: 12px;
                        color: #999999;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow:ellipsis;
                    }
                }
            }
        }
        .detail-pagination{
            margin-top: 20px;
            text-align: center;
            width: 856px;
        }
    }
    .toUp{
        width: auto;
        height: auto;
        position: fixed;
        bottom:244px;
        cursor: pointer;
    }
</style>
<script>
    import uiHeader from 'uiHeader';
    import uiFooter from 'uiFooter';
    import $ from "jquery";
    import commonPagination from 'commonPagination';
    import api from 'train.server';
    import OnlineService from 'onlineService';

    module.exports = Vue.component('train-list',{
        data(){
            return{
                userInfo:window.PAGE_DATA.commonData.userInfo || {},
    			nav:      window.PAGE_DATA.commonData.nav       || [],
                userList: window.PAGE_DATA.commonData.toUcenter || [],
                loginUrl: window.PAGE_DATA.commonData.loginUrl || '',
                logoutUrl: window.PAGE_DATA.commonData.logoutUrl || '',
                registerUrl: window.PAGE_DATA.commonData.registerUrl || '',
                homeUrl:window.PAGE_DATA.commonData.homeUrl || '',
                ucenterUrl:window.PAGE_DATA.commonData.ucenterUrl || '',
                mainUrl:window.PAGE_DATA.webSite.navigate.mainUrl || '',
                pxUrl:window.PAGE_DATA.webSite.navigate.pxUrl || '',
                typeName:window.PAGE_DATA.webSite.navigate.categoryName,
                listInfo:window.PAGE_DATA.webSite.listsInfo.list,
                pageIndex:1,
                totalNum:window.PAGE_DATA.webSite.listsInfo.totalNum,
                cid:window.PAGE_DATA.webSite.cid,
                recommonAnalystArr:[],
                isShowToUp:false,
            }
        },
        components:{
            commonPagination, OnlineService
        },
        mounted:function(){
            $("head").append('<meta name="description" content="'+window.PAGE_DATA.commonData.meta.description+'" />');
            $("head").append('<meta name="keywords" content="'+window.PAGE_DATA.commonData.meta.keywords+'" />');
            this.getRecommonAnalyst();
            let _this = this;
            let left = ($(window).width() - 1120) / 2 + 1120 + 10;
            $(".toUp").css({
               left:left+"px"
            })
            $(window).scroll(function() {
                if ($(this).scrollTop() - $(window).height() > 0) {
                    _this.isShowToUp = true;
                    $(".toUp").css({
                        left:left+"px"
                    })
                } else {
                    _this.isShowToUp = false;
                }
            })
        },
        methods:{
            clickToUp:function(){
                $('html, body').animate({
                    scrollTop: 0
                }, 500);
            },
            changeItem:function(index){
                this.pageIndex = index;
                this.getList();
                $('html, body').animate({
                    scrollTop: 0
                }, 500);
            },
            openUrl:function(url){
                window.open(url)
            },
            getList:function(){
                let _this = this;
                let param = {
                    cid:this.cid,
                    page:this.pageIndex
                }
                api.listsInfo(param)
                .then(function(res){
                    if (res.data.header.code == 1){
                        _this.listInfo = res.data.body.list;
                    }
                },function(res){

                })
            },
            getRecommonAnalyst:function(){
                let _this = this;
                api.recommonAnalyst()
                .then(function(res){
                    if (res.data.header.code == 1){
                        _this.recommonAnalystArr = res.data.body.list;
                    }
                },function(res){

                })
            }
        }
    })
</script>



// WEBPACK FOOTER //
// src/components/train/view/trainList/trainList.vue